import { useEffect } from 'react';

import useAuth from 'client/utils/auth/useAuth';
import { useIntl } from 'react-intl';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';
import { useLoaderData, useActionData, useNavigate, useSubmit, useSearchParams } from 'react-router';

import Page from 'client/components/aria/Page/Page';
import Alert from 'client/components/ui/Alert/Alert';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';

import { HOME_PAGE, TERMS_AND_CONDITIONS_PAGE } from 'client/utils/routes/routeConstants';

import styles from 'client/pages/TermsPage/TermsPage.module.scss';
import Markdown from 'client/components/aria/MarkDown/Markdown';

const TermsPage = () => {
    const { user, loadUser, signOutByChoice } = useAuth();
    const intl = useIntl();
    useLocaleAutoSwitch();
    const { terms } = useLoaderData();
    const navigate = useNavigate();
    const actionData = useActionData();
    const submit = useSubmit();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (actionData?.redirect) {
            loadUser();
            navigate(actionData.redirect);
        }
    }, [actionData]);

    useEffect(() => {
        if (user?.pendingTermsApproval === false && searchParams.get('redirect')) {
            navigate(searchParams.get('redirect'));
        }
    }, [user]);

    const handleAccept = () => {
        submit(
            { modifiedDate: new Date().toISOString(), redirect: searchParams.get('redirect') || HOME_PAGE },
            {
                method: 'PATCH',
                action: TERMS_AND_CONDITIONS_PAGE
            }
        );
    };

    return (
        <Page
            title={intl.formatMessage({ id: 'termsPage.title' })}
            data-testid="termsPage"
        >
            {user?.pendingTermsApproval
                ? <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <Alert className={styles.alert} data-testid="termsPage.scroll" variant="info" >
                            <span data-testid="termsPage.message.scroll" className={['govuk-body govuk-!-font-weight-bold', styles.alertText].join(' ')}>
                                {intl.formatMessage({ id: 'termsPage.message.scroll' })}
                            </span>
                        </Alert>
                    </div>
                </div>
                : null
            }
            <div className="govuk-grid-row">
                <div
                    data-testid="termsPage.content"
                    className="govuk-grid-column-full"
                >
                    <Markdown>
                        { terms?.markdown }
                    </Markdown>
                </div>
            </div>

            {user?.pendingTermsApproval
                ? <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <ButtonGroup className={styles.buttons}>
                            <Button
                                data-testid="termsPage.button.disagree"
                                variant="error"
                                onPress={signOutByChoice}
                            >
                                {intl.formatMessage({ id: 'disagree' })}
                            </Button>
                            <Button
                                data-testid="termsPage.button.agree"
                                variant="success"
                                onPress={handleAccept}
                            >
                                {intl.formatMessage({ id: 'agree' })}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
                : null }
        </Page>
    );
};

export default TermsPage;
